const ReactVideoBanner = props => {
  const deadline = props.deadline;
  const currentDesktopImgPoster = props.currentDesktopImgPoster;
  const currentDesktopVideo = props.currentDesktopVideo;
  const scheduledDesktopImgPoster = props.scheduledDesktopImgPoster;
  const scheduledDesktopVideo = props.scheduledDesktopVideo;
  const currentMobileImgPoster = props.currentMobileImgPoster;
  const currentMobileVideo = props.currentMobileVideo;
  const scheduledMobileImgPoster = props.scheduledMobileImgPoster;
  const scheduledMobileVideo = props.scheduledMobileVideo;
  let contentContainerClass = 'video-banner-content-container';
  if (props.leftAlign) {
    contentContainerClass = 'left-align-Container';
  } else if (props.bottomAlign) {
    contentContainerClass = 'bottom-left-align-container';
  }
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });
  if (windowWidth > 589) return /*#__PURE__*/React.createElement("div", {
    className: "tlf-banner"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.url ? props.url : "#"
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-banner-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-video"
  }, deadline && Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  })) > 0 ? /*#__PURE__*/React.createElement("video", {
    key: currentDesktopVideo + "1",
    playsInline: "playsInLine",
    autoPlay: "autoplay",
    loop: "loop",
    muted: "muted",
    width: "100%",
    preload: "metadata",
    poster: currentDesktopImgPoster
  }, /*#__PURE__*/React.createElement("source", {
    src: currentDesktopVideo,
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("img", {
    src: currentDesktopImgPoster,
    alt: "TLF model posing with new release"
  })) : /*#__PURE__*/React.createElement("video", {
    key: scheduledDesktopVideo + "2",
    playsInline: "playsInLine",
    autoPlay: "autoplay",
    loop: "loop",
    muted: "muted",
    width: "100%",
    preload: "metadata",
    poster: scheduledDesktopImgPoster
  }, /*#__PURE__*/React.createElement("source", {
    src: scheduledDesktopVideo,
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("img", {
    src: scheduledDesktopImgPoster,
    alt: "TLF model posing with new release"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "video-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children)))));else return /*#__PURE__*/React.createElement("div", {
    className: "tlf-banner"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.url ? props.url : "#"
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-banner-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-video"
  }, deadline && Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  })) > 0 ? /*#__PURE__*/React.createElement("video", {
    key: currentMobileVideo + "3",
    playsInline: "playsInLine",
    autoPlay: "autoplay",
    loop: "loop",
    muted: "muted",
    width: "100%",
    preload: "metadata",
    poster: currentMobileImgPoster
  }, /*#__PURE__*/React.createElement("source", {
    src: currentMobileVideo,
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("img", {
    src: currentMobileImgPoster,
    alt: "male model wearing miami night shorts and Quiet Luxery tee"
  })) : /*#__PURE__*/React.createElement("video", {
    key: scheduledMobileVideo + "4",
    playsInline: "playsInLine",
    autoPlay: "autoplay",
    loop: "loop",
    muted: "muted",
    width: "100%",
    preload: "metadata",
    poster: scheduledMobileImgPoster
  }, /*#__PURE__*/React.createElement("source", {
    src: scheduledMobileVideo,
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("img", {
    src: scheduledMobileImgPoster,
    alt: "male model wearing miami night shorts and Quiet Luxery tee"
  })), /*#__PURE__*/React.createElement("div", {
    className: "video-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children))))));
};

// if (document.getElementById('reactVideoBanner')) {
//     const domContainerForReactVideoBanner = document.getElementById('reactVideoBanner');

//     const rootForReactVideoBanner = ReactDOM.createRoot(domContainerForReactVideoBanner);
//     rootForReactVideoBanner.render(<ReactMainBanner
//         deadline={domContainerForReactVideoBanner.dataset.deadline}

//         currentDesktopImgPoster={domContainerForReactVideoBanner.dataset.currentDesktopImgPoster}
//         currentDesktopVideo={domContainerForReactVideoBanner.dataset.currentDesktopVideo}
//         scheduledDesktopImgPoster={domContainerForReactVideoBanner.dataset.scheduledDesktopImgPoster}
//         scheduledDesktopVideo={domContainerForReactVideoBanner.dataset.scheduledDesktopVideo}

//         currentMobileImgPoster={domContainerForReactVideoBanner.dataset.currentMobileImgPoster}
//         currentMobileVideo={domContainerForReactVideoBanner.dataset.currentMobileVideo}
//         scheduledMobileImgPoster={domContainerForReactVideoBanner.dataset.scheduledMobileImgPoster}
//         scheduledMobileVideo={domContainerForReactVideoBanner.dataset.scheduledMobileVideo}
//     />);
// }
